import { HttpRequest } from '@angular/common/http';

export function getHttpMocks(): HttpMocks {
  return [];
}

export interface HttpMock {
  delete?(request: HttpRequest<any>, username?: string): any;
  get?(request: HttpRequest<any>, username?: string): any;
  post?(request: HttpRequest<any>, username?: string): any;
  put?(request: HttpRequest<any>, username?: string): any;

  url: RegExp | string;
}

export type HttpMocks = HttpMock[];
